module.exports = __webpack_public_path__ + "static/img/Fashion Accessories.78aa077.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Fashion Accessories.jpg
// module id = mhPC
// module chunks = 1